import { ModalWrapper } from "../../utils/fw"


export default {
	background: "https://assets.swoogo.com/uploads/full/1464068-618aa058e1e95.jpg",
	links: [
		{
			height: "6.3%",
			href: "/lobby",
			label: "To Lobby",
			left: "0%",
			top: "2%",
			width: "11.5%",
		},
		{
			height: "44.3%",
			href: "/breakout-one",
			label: "Breakout 1",
			left: "0%",
			top: "36%",
			width: "22.5%",
			CometChatID: "ccm"
		},
		{
			height: "45.9%",
			href: "/breakout-two",
			label: "Breakout 2",
			left: "22.8%",
			top: "33.8%",
			width: "23.7%",
			CometChatID: "experts"
		},
		{
			height: "40.6%",
			href: "/breakout-three",
			label: "Breakout 3",
			left: "54.2%",
			top: "35.1%",
			width: "24.5%",
			CometChatID: "tech"
		},
		{
			height: "35.3%",
			href: "/breakout-four",
			label: "Breakout 4",
			left: "81.9%",
			top: "35.5%",
			width: "16.8%",
			CometChatID: "best"
		},
		{
			height: "20.3%",
			label: "View Agendas",
			left: "51.9%",
			top: "75.5%",
			width: "7.8%",
			onClick: () => { document.getElementById("quadient2021-agendas").click() }

		},
	],
	name: "breakouts",
}
